import { Injectable, inject } from '@angular/core';
import { ProjectModel } from '../../../../core/models/project/project.model';
import { ProjectDetailDataStore } from './project-detail-data.store';
import { take } from 'rxjs/operators';
import { cloneDeep } from 'lodash-es';
import { Subject } from 'rxjs';
import { assert } from '../../../../core/assert/assert';
import { ProjectTaskModel } from '../../../../core/models/project/project-task.model';

// Component Service: This service is solely used for the project module.
@Injectable()
export class ProjectDataService {
  public userOperationConducted$ = new Subject<boolean>();
  private readonly projectDetailDataStore = inject(ProjectDetailDataStore);

  public addProject(project: ProjectModel): void {
    assert(project !== null, 'Project model is invalid.');
    this.projectDetailDataStore.addProject(project);
  }

  public getProjectClone(): ProjectModel {
    return cloneDeep(this.getProject());
  }

  public updateProject(project: ProjectModel): void {
    this.projectDetailDataStore.updateProject(project);
  }

  public resetProjectStore(): void {
    this.projectDetailDataStore.reset();
  }

  public getTasks(
    project: ProjectModel,
    isBillable: boolean | null,
    includeDefaultTask: boolean,
  ): readonly ProjectTaskModel[] {
    assert(project !== null, 'Project model is invalid.');

    let tasks = project.tasks;
    if (isBillable !== null) {
      tasks = tasks.filter((task) => task.isBillable);
    }

    if (!includeDefaultTask) {
      return tasks.filter((task) => !task.isDefault);
    }

    return tasks;
  }

  private getProject(): ProjectModel {
    let loadedProject: ProjectModel;
    this.projectDetailDataStore
      .selectProject()
      .pipe(take(1))
      .subscribe((project) => {
        loadedProject = project;
      });
    return loadedProject;
  }
}
